import { register } from 'swiper/element/bundle'

import ReactGA from 'react-ga4'
import AddToCalendarButton from '../util/AddToCalendar'
register()
export const ActivitiesSwiper = () => {
    const events = {
        eventBalta: {
            title: 'Balta Boss Battle',
            dates: {
                '8/30': ['10:15~', '12:15~', '2:15~', '4:15~'],
                '8/31': ['10:15~', '12:15~', '2:15~', '4:15~'],
                '9/1': ['10:15~', '12:15~', '2:15~', '4:15~'],
                '9/2': ['10:15~', '12:15~', '2:15~', '4:15~'],
            },
            description: (
                <>
                    <p>
                        Think you're as tough as a member of the Balta Seaforce? Put your skills to the test in a Ys X:
                        Nordics boss time attack!
                    </p>
                    <p className='mt-4'>To participate, please come to the demo booth 10 minutes before the session.</p>
                    <p>(First come, first served)</p>
                </>
            ),
            location: 'Blue Dragon Theatre, Summit Building',
            timezone: 'America/Los_Angeles',
            Prize: "Ys X: Nordics: The Runestones' Legacy Acrylic Stand",
        },
        eventMarin: {
            title: "Marin's High Score Challenge",
            dates: {
                '8/30': ['10:45~', '12:45~', '2:15~', '4:45~'],
                '8/31': ['10:45~', '12:45~', '2:15~', '4:45~'],
                '9/1': ['10:45~', '12:45~', '2:15~', '4:45~'],
                '9/2': ['10:45~', '12:45~', '2:15~', '4:45~'],
            },

            description: (
                <>
                    <p>
                        Experience the stylish combat of REYNATIS and compete for the highest score! Winners will
                        receive a special prize.
                    </p>
                    <p className='mt-4'>To participate, please come to the demo booth 10 minutes before the session.</p>
                    <p>(First come, first served)</p>
                </>
            ),
            location: 'Blue Dragon Theatre, Summit Building',
            timezone: 'America/Los_Angeles',
            Prize: 'To be determined',
        },
        eventVan: {
            title: "Van's Fishing Challange",
            dates: {
                '8/30': ['10:30~', '12:30~', '2:30~', '4:30~'],
                '8/31': ['10:30~', '12:30~', '2:30~', '4:30~'],
                '9/1': ['10:30~', '12:30~', '2:30~', '4:30~'],
                '9/2': ['10:30~', '12:30~', '2:30~', '4:30~'],
            },
            description: (
                <>
                    <p>
                        Take a break from fighting with Trails through Daybreak II's popular fishing mini-game and
                        compete for the most catches! Winners will receive a special prize.
                    </p>
                    <p className='mt-4'>To participate, please come to the demo booth 10 minutes before the session.</p>
                    <p>(First come, first served)</p>
                </>
            ),
            timezone: 'America/Los_Angeles',
            Prize: 'Original Acrylic Stand',
        },
        eventPutty: {
            title: "Putty's Beginner Challenge",
            dates: {
                '8/30': ['11:00~', '1:00~', '3:00~', '5:00~'],
                '8/31': ['11:00~', '1:00~', '3:00~', '5:00~'],
                '9/1': ['11:00~', '1:00~', '3:00~', '5:00~'],
                '9/2': ['11:00~', '1:00~', '3:00~', '5:00~'],
            },
            description: (
                <>
                    <p>
                        Get some hands-on time with Phantom Brave: The Lost Hero alongside members of the NIS America
                        team. Learn about this charming game and take on some beginner-friendly challenges! Winners will
                        receive a special prize.
                    </p>
                    <p className='mt-4'>To participate, please come to the demo booth 10 minutes before the session.</p>
                    <p>(First come, first served)</p>
                </>
            ),
            location: 'Blue Dragon Theatre, Summit Building',
            timezone: 'America/Los_Angeles',
            Prize: 'Putty plushie',
        },
    }

    return (
        <div className='w-full border-stone-400 mt-8'>
            {/* Navigation Buttons */}
            <div
                className='swiper-button-prev'
                style={{
                    position: 'absolute',
                    top: '50%',
                    left: '-30px',
                    transform: 'translateY(-50%)',
                    zIndex: 10,
                }}
            ></div>
            <div
                className='swiper-button-next'
                style={{
                    position: 'absolute',
                    top: '50%',
                    right: '-30px',
                    transform: 'translateY(-50%)',
                    zIndex: 10,
                }}
            ></div>

            <div className='w-full h-full'>
                <div className=''>
                    <swiper-container
                        navigation={{
                            nextEl: '.swiper-button-next',
                            prevEl: '.swiper-button-prev',
                        }}
                        loop='false'
                        autoplay='false'
                        free-mode='true'
                        style={{
                            position: 'unset',
                            '--swiper-theme-color': 'orange',
                        }}
                        breakpoints={JSON.stringify({
                            280: {
                                slidesPerView: 1.1,
                                spaceBetween: 5,
                            },
                            768: {
                                slidesPerView: 1.3,
                                spaceBetween: 5,
                            },

                            1024: {
                                slidesPerView: 1.3,
                                spaceBetween: 5,
                            },
                        })}
                    >
                        {Object.entries(events).map(([key, item], i) => (
                            <>
                                <swiper-slide key={i}>
                                    <img
                                        className='w-full'
                                        src={`${process.env.PUBLIC_URL}/images/event/event${i + 1}.webp`}
                                        alt={item.name}
                                    />{' '}
                                    <div className='flex flex-col  justify-between font-bold text-center min-h-[500px] md:min-h-[580px] lg:min-h-[530px] text-subsmall md:text-base '>
                                        <div className='flex flex-row justify-center border-b border-stone-400 items-stretch'>
                                            <div className='h-auto  w-1/4 md:w-1/4 text-white bg-stone-500 py-2 items-center'>
                                                <p>Title</p>
                                            </div>
                                            <div className='w-3/4 md:w-3/4 bg-white px-2 items-center safari-center'>
                                                <p className='mx-auto text-navy'>{item.title}</p>
                                            </div>
                                        </div>{' '}
                                        <div className='flex flex-row grow border-b border-stone-400 '>
                                            <div className='h-auto w-1/4 md:w-1/4 text-white bg-stone-500 safari-center'>
                                                <p className='mx-auto py-2'>Description</p>
                                            </div>
                                            <div className='w-3/4 md:w-3/4 bg-white px-2 py-4 safari-center'>
                                                <p className='mx-auto text-navy'>{item.description}</p>
                                            </div>
                                        </div>{' '}
                                        <div className='bg-white flex flex-row border-b border-stone-400'>
                                            <div className='h-auto w-1/4 md:w-1/4 text-white bg-stone-500 border-white safari-center'>
                                                <p className='py-2 mx-auto'>Time Slot</p>
                                            </div>
                                            <div className='w-3/4 flex flex-col justify-center items-center mx-auto text-navy py-4 px-2'>
                                                {Object.entries(item.dates).map(([date, times], index) => (
                                                    <div key={index} className='flex items-center space-x-4'>
                                                        <p className='text-navy font-bold'>{date}</p>
                                                        <div className='flex space-x-2'>
                                                            {times.map((time, i) => (
                                                                <p key={i} className=''>
                                                                    {time}
                                                                </p>
                                                            ))}
                                                        </div>
                                                    </div>
                                                ))}{' '}
                                                <p className='text-subsmall md:text-sub mt-4'>
                                                    * Each session will last 15 minutes.
                                                </p>{' '}
                                                <p className='text-subsmall md:text-sub'>
                                                    * Please note that the schedule is subject to change.
                                                </p>
                                            </div>
                                        </div>{' '}
                                    </div>
                                </swiper-slide>
                            </>
                        ))}
                    </swiper-container>
                </div>{' '}
            </div>
        </div>
    )
}
